export enum TreatmentType {
  WEEK_14 = "week14",
  WEEK_28 = "week28",
}
